import { mapGetters, mapActions } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import { setStorage, getStorage } from '../../../common/utilities/nojq/_localstorage.js';

export default {
    name: 'propertyCommute',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtInputGeo,
    },
    props: ['disableCollapse'],
    data() {
        return {
            commuteObj: {
                name: '',
                distance: '',
                carCommute: '',
                bicycleCommute: '',
                walkCommute: '',
                mapUrl: '',
            },
            geoInfo: {
                text: '',
                geo: null,
            },
            fullCommuteArray: [],
            setStorageData: [],
        };
    },
    watch: {
        geoInfo(newVal) {
            if (newVal) {
                const source = this.dpp.geo;
                const destinationLocation = newVal && newVal.geo && newVal.geo.geometry && newVal.geo.geometry.location;
                const destinationName = newVal && newVal.text && newVal.text.replace(/, USA/, '');

                if (destinationName && destinationLocation) {
                    this.setCommuteStorageAndFillModelData(
                        { lat: source.lat, lng: source.lng, propertyId: this.dpp.propertyId },
                        [
                            {
                                name: destinationName,
                                lat: destinationLocation.lat(),
                                lng: destinationLocation.lng(),
                            },
                        ],
                        true
                    );
                }
            }
        },
    },
    methods: {
        ...mapActions('dpp', ['fetchCommuteData']),
        ...mapGetters('glb', ['getComplianceMethod']),
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
        removeCommute(index) {
            this.fullCommuteArray.splice(index, 1);
            this.setStorageData.splice(index, 1);
            setStorage('commuteInfoByListing', this.setStorageData);
        },
        getMilesTxt(distance) {
            return Number(distance) > 1 ? 'miles' : 'mile';
        },
        _getLocationData(data) {
            return {
                lat: data.lat,
                lng: data.lng,
                name: data.name,
            };
        },
        setCommuteStorageAndFillModelData(sourceInput, destinationInputArr, isNewSearch = false) {
            let source = this._getLocationData({ lat: sourceInput.lat, lng: sourceInput.lng });
            let destination = {};
            if (!isNewSearch) {
                this.setStorageData = [];
            }
            destinationInputArr.forEach((item) => {
                const encodedText = btoa(`${item.name}_${Date.now()}`);
                destination[encodedText] = this._getLocationData({ lat: item.lat, lng: item.lng, name: item.name });
            });
            this.fetchCommuteData({ source, destination }).then((response) => {
                if (response) {
                    let storageData = [];
                    Object.keys(destination).forEach((item) => {
                        storageData.push({ ...destination[item], ...response[item] });
                    });
                    storageData.forEach((eachCommute) => {
                        this.fullCommuteArray.push({
                            name: eachCommute.name,
                            distance: eachCommute.distance,
                            carCommute: eachCommute.carCommute,
                            bicycleCommute: eachCommute.bicycleCommute,
                            walkCommute: eachCommute.walkCommute,
                            mapUrl: eachCommute.mapUrl,
                        });
                        this.setStorageData.push({
                            name: eachCommute.name,
                            lat: eachCommute.lat,
                            lng: eachCommute.lng,
                        });
                    });
                    setStorage('commuteInfoByListing', this.setStorageData);
                }
            });
            this.geoInfo.text = '';
            this.geoInfo.geo = null;
            this.$refs.addressInput.reset();
        },
        inital() {
            var storageCommuteObj = getStorage('commuteInfoByListing');
            this.fullCommuteArray = [];
            if (storageCommuteObj && storageCommuteObj.length) {
                var source = this.dpp.geo;
                this.setCommuteStorageAndFillModelData({ lat: source.lat, lng: source.lng, propertyId: this.dpp.propertyId }, storageCommuteObj);
            }
        },
    },
    mounted() {
        this.inital();
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getseoNearbyCity']),
        haslatLng() {
            if (this.dpp && this.dpp.geo && this.dpp.geo.lat && this.dpp.geo.lng) {
                return true;
            } else {
                return false;
            }
        },
    },
};
